<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="grouping-card">
    <div class="grouping-card__left">
      <p class="grouping-card__title">
        <slot name="title">
          {{ t('stayDisplayer.grouping.title') }}
        </slot>
      </p>
      <slot name="left" />
    </div>
    <div class="grouping-card__right">
      <slot name="right" />
    </div>
    <div
      v-if="$slots.footer"
      class="grouping-card__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/design-system/tokens/colors';

.grouping-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid $grouping-border-color;
  border-radius: 3px;
  padding-top: 15px;

  &__left {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 20px 15px;
    border-right: 1px solid $grouping-border-color;
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0 20px 15px;
  }

  &__title {
    font-size: 21px;
    font-weight: 400;
    line-height: 1.4;
    margin: 0;
  }

  &__footer {
    grid-column: 1 / -1;
  }
}
</style>
